import api from "src/services/api";

export interface UnidadNegocioMarcacion {
  id: number;
  codigo: string;
  unidad: string;
  activo: boolean;
  seleccionada: boolean;
}

export const obtenerUnidadesMarcacion = async (): Promise<UnidadNegocioMarcacion[]> => {
  const { data } = await api.get<{ datos?: UnidadNegocioMarcacion[] }>(
    "inicio/marcaciones-unidades"
  );
  return data?.datos || [];
};

export const actualizarUnidadesMarcacion = async (
  seleccionadas: number[]
): Promise<UnidadNegocioMarcacion[]> => {
  const { data } = await api.put<{ datos?: UnidadNegocioMarcacion[] }>(
    "inicio/marcaciones-unidades",
    { seleccionadas }
  );
  return data?.datos || [];
};

export const sincronizarUnidadesMarcacion = async (): Promise<{
  insertados: number;
  datos: UnidadNegocioMarcacion[];
}> => {
  const { data } = await api.post<{
    insertados?: number;
    datos?: UnidadNegocioMarcacion[];
  }>("inicio/marcaciones-unidades/sync");
  return {
    insertados: Number(data?.insertados || 0),
    datos: data?.datos || [],
  };
};
